const selectors = {
  collapsibleContent: "collapsible-content",
  collapsibleMedia: "collapsible-media",
  collapsibleSectionAd: "collapsible-section-ad",
  nonAccordionHeading: "not-collapsible",
  seeAll: "see-all",
  toTop: "to-top",
};

export default selectors;
